<template>
  <div>
    <PersonalProfiles />

    <v-dialog v-model="personalProfileSelected" fullscreen scrollable hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-card-title :style="style" class="px-2">
          <v-btn icon @click="deselectProfile">
            <v-icon color="white">mdi-keyboard-backspace</v-icon>
          </v-btn>
          Profile Details
        </v-card-title>
        <v-card-text class="px-0 py-0">
          <PersonalProfileDetail />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<style>
</style>

<script>
import { mapState, mapActions } from 'vuex';

import PersonalProfiles from '@/components/Client/Profiles/PersonalProfiles.vue';
import PersonalProfileDetail from '@/components/Client/Profiles/PersonalProfileDetail.vue';

export default {
  components: {
    PersonalProfiles,
    PersonalProfileDetail
  },
  data: function () {
    return {
      style: {
        'background-color': this.$vuetify.theme.themes.light.integrity,
        color: 'white'
      }
    };
  },
  computed: {
    ...mapState(['client', 'selectedProfileId']),
    personalProfileSelected: function () {
      return (this.selectedProfileId || null) !== null;
    }
  },
  beforeMount: function () {
    this.deselectProfile();
  },
  methods: {
    ...mapActions(['setSelectedProfile']),
    deselectProfile: function () {
      this.setSelectedProfile(null);
    }
  }
};
</script>
